export default __webpack_public_path__ + "static/media/welcome.c826e780.png";